import { takeLatest, put, call } from "redux-saga/effects";
import { sagaActions } from "../../actions";
import {
  fetchOwnRequests,
  fetchOwnRequestsCompleted,
} from "../../slices/own_requests";
import { workflowsService } from "../../../../../src/core/workflows/workflows_service";

async function handleFetchOwnRequests({ page, items }) {
  return await workflowsService.listUserOwnership(page, items);
}

async function handleGetUsers({ tokens, page, items, filters }) {
  return await workflowsService.listUsers(tokens, page, items, filters);
}

function* listOwnRequestsSaga({ payload }) {
  try {
    yield put(fetchOwnRequests());
    const ownRequestsData = yield call(handleFetchOwnRequests, payload);
    const usersTokens = ownRequestsData.data.map((item) => item.user_token);
    const { data: usersData } = yield call(handleGetUsers, {
      tokens: usersTokens,
      page: 1,
      items: 10,
      filters: {},
    });

    ownRequestsData.data = ownRequestsData.data.map((item) => {
      const user = usersData.find((user) => user.token === item.user_token);
      return {
        ...item,
        fullName: `${user.name} ${user.last_name}`,
      };
    });
    yield put(fetchOwnRequestsCompleted(ownRequestsData));
  } catch (error) {
    console.error(error.message);
  }
}

export function* listOwnRequestsWatcherSaga() {
  yield takeLatest(
    sagaActions.START_FETCH_LIST_OWN_REQUESTS,
    listOwnRequestsSaga
  );
}
